<div style="height: 100vh; background-color: cadetblue; color: #ef2424; font-size: 4rem;display: flex;
    align-items: center;
    justify-content: center;" >
  Welcome !! to the world of learning !!!!!!!!

</div>